import { render } from "./ResultSection.vue?vue&type=template&id=fb71d4e2"
import script from "./ResultSection.vue?vue&type=script&lang=js"
export * from "./ResultSection.vue?vue&type=script&lang=js"

import "./ResultSection.vue?vue&type=style&index=0&id=fb71d4e2&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__